import * as React from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import BiddingOptions from "./biddingOptions";
import Multipliers from "./multipliers";
import BiddingRules from "./biddingRules";
import {useDispatch, useSelector} from "react-redux";
import ExtraBid from "./extraBid";
import KayakMultipliers from "./kayak/multipliers";
import { updateBiddingLevel, updateEditBidHotels } from "store/slices/editBid/editBid";

export default function EditBidContainer() {
  const [value, setValue] = React.useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const dispatch = useDispatch()
  const platform = useSelector((state) => state?.metaSearch?.platform);
  const {hotel_id = [], hotelList = [], groupList = [], level , group_id = []} = useSelector(state => state?.account);

  React.useEffect(() => {
    if(level === "HOTEL") {
      dispatch(updateBiddingLevel("hotels"))
      dispatch(updateEditBidHotels(hotelList?.filter(h => hotel_id?.includes(h.hotel_id)).map(hotel => ({
        id: hotel?.hotel_id,
        name: hotel?.hotel_name,
        isSelected: true
      }))))
    } else {
      dispatch(updateBiddingLevel("groups"))
      dispatch(updateEditBidHotels(groupList?.filter(g => group_id?.includes(g.id)).map(group => ({
        id: group?.id,
        name: group?.name,
        isSelected: true
      }))))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[])
  function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        style={{ position: "relative" }}
        {...other}
      >
        {value === index && <Box sx={{ padding: "18px" }}>{children}</Box>}
      </div>
    );
  }

  CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
  };

  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }
  const [tabs, setTabs] = React.useState([]);
  const [layouts, setLayouts] = React.useState([]);
  React.useEffect(() => {
    switch (platform?.[0]?.id) {
      case "bing":
        setTabs(["Bidding options", "Multipliers"]);
        setLayouts([<BiddingOptions />, <Multipliers />]);
        break;
      case "kayak":
        setTabs(["Bidding options", "Extra Bid", "Multipliers"]);
        setLayouts([<BiddingOptions />, <ExtraBid />, <KayakMultipliers />]);
        break;
      case "skyScanner":
        setTabs(["Bidding options"]);
        setLayouts([<BiddingOptions />]);
        break;
      case "trivagoSponsoredListing":
        setTabs(["Bidding options", "Bidding rules"]);
        setLayouts([<BiddingOptions />, <BiddingRules />]);
        break;
     
      case "wego":
        setTabs(["Status"]);
        setLayouts([<BiddingOptions />]);
        break;

      default:
        setTabs(["Bidding options", "Bidding rules", "Multipliers"]);
        setLayouts([<BiddingOptions />, <BiddingRules />, <Multipliers />]);
        break;
    }
    setValue(0);
  }, [platform]);

  return (
    <Box sx={{ width: "100%" }}>
      <Box
        sx={{
          borderBottom: 1,
          borderColor: "divider",
          "& .MuiTabs-flexContainer": {
            justifyContent: "flex-end",
          },
        }}
      >
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
          TabIndicatorProps={{
            sx: {
              display: "none",
            },
          }}
          sx={{
            height: "26px",
            minHeight: "26px",
            "& .MuiButtonBase-root": {
              fontSize: "12px",
              fontWeight: 400,
              textTransform: "none",
              backgroundColor: "#BAB7B7",
              borderRadius: "10px 10px 0px 0px",
              marginRight: "3px",
              height: "26px !important",
              width: "130px!important",
              color: "white",
            },
            "& .Mui-selected": {
              backgroundColor: "#61D5A9",
              color: "white !important",
            },
          }}
        >
          {tabs.map((tab, i) => {
            return (
              <Tab
                sx={{ minHeight: "26px", height: "26px" }}
                label={tab}
                {...a11yProps(i)}
              />
            );
          })}
        </Tabs>
      </Box>
      {layouts.map((layout, i) => {
        return (
          <CustomTabPanel value={value} index={i}>
            {layout}
          </CustomTabPanel>
        );
      })}
    </Box>
  );
}
